import React from 'react'
import { Link } from 'react-router-dom'

const CompletedClaim = ({ claim }) => {
  const status = claim?.status?.status
  const altText = claim?.status?.alt_public_text
  const description = claim?.status?.alt_description || claim?.status?.description

  const renderStatusBox = () => {
    switch (status) {
      case 'approved':
        return (
          <div className="bg-green-500 text-white rounded-md py-4 px-6 mb-6">
            <p className="font-semibold text-sm mb-2">{altText || 'Approved'}</p>
            <p className="text-sm">{description || 'Your claim has been approved.'}</p>
          </div>
        )
      case 'declined':
        return (
          <div className="bg-red-500 text-white rounded-md py-4 px-6 mb-6">
            <p className="font-semibold text-sm mb-2">{altText || 'Declined'}</p>
            <p className="text-sm">{description || 'Unfortunately your claim has not been approved.'}</p>
            <Link to="/sai/claims" className="underline font-medium text-sm">
              View in Closed Claims
            </Link>
          </div>
        )
      case 'pending':
      default:
        return (
          <div className="bg-yellow-500 text-white rounded-md py-4 px-6 mb-6">
            <p className="font-semibold text-sm mb-2">{altText || 'Pending Review'}</p>
            <p className="text-sm">{description || 'Your claim is under review.'}</p>
          </div>
        )
    }
  }

  return (
    <div>
      <div className="w-full max-w-2xl p-8 text-center mx-auto">
        <h2 className="text-3xl font-semibold text-gray-700 mb-4">Thank you</h2>

        <div className="flex justify-center mb-4">
          <div className="rounded-full border-4 border-dashed border-blue-400 p-6">
            <svg xmlns="http://www.w3.org/2000/svg"
                 className="h-12 w-12 text-blue-500"
                 fill="none"
                 viewBox="0 0 24 24"
                 stroke="currentColor"
                 strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <p className="text-lg font-medium text-gray-700 mb-6">
          Thank you for submitting your payment request for consideration
        </p>

        {renderStatusBox()}

        <div>
          <Link
            to={`/sai/claims?actionClaimId=${claim?.id}`}
            className="text-blue-600 text-sm underline font-medium"
          >
            Click here to go back
          </Link>
        </div>
      </div>

      <div className="mt-8 text-xs text-gray-500 text-center">
        <p>01773851079 Schools Mutual, a trading name of SAS Mutual CIC (12499719)</p>
        <p>a: Trigg House, 11 Maisies Way, South Normanton, DE55 2DS. ICO License No: ZA757213</p>
      </div>
    </div>
  )
}

export default CompletedClaim
